import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row, Tab, Nav, Form } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import ExpenseBifurcationTable from './ExpenseBifurcationTable';
import SimpleBarReact from 'simplebar-react';
import classNames from 'classnames';

const TabTitle = ({ title }) => (
  <Flex className="p-3 ps-2 text-start cursor-pointer gap-1">
    <div className="ms-2">
      <h6 className="mb-0 lh-1">{title}</h6>
    </div>
  </Flex>
);

const ExpenseBifurcation = ({ tableData, className }) => {
  return (
    <Card className={classNames(className, 'overflow-hidden')}>
      <Tab.Container id="top-course-tab" defaultActiveKey="treePlanting">
        <SimpleBarReact>
          <Card.Header className="p-0">
            <Nav className="nav-tabs top-courses-tab border-0 flex-nowrap">
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="treePlanting">
                  <TabTitle title="Tree  Planting" isActive={true} />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  className="mb-0"
                  eventKey="renewableEnergyInfrastructure"
                >
                  <TabTitle
                    title="Renewable Energy Infrastructure"
                    isActive={false}
                  />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="carbonMonitoring">
                  <TabTitle
                    title="Carbon Monitoring & Reporting"
                    isActive={false}
                  />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="projectManagement">
                  <TabTitle
                    title="Project Management & Administration"
                    isActive={false}
                  />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
        </SimpleBarReact>

        <Card.Body className="p-0">
          <Tab.Content>
            <Tab.Pane unmountOnExit eventKey="treePlanting">
              <ExpenseBifurcationTable tableData={tableData.slice(0, 4)} />
            </Tab.Pane>
            <Tab.Pane unmountOnExit eventKey="renewableEnergyInfrastructure">
              <ExpenseBifurcationTable tableData={tableData.slice(4, 8)} />
            </Tab.Pane>
            <Tab.Pane unmountOnExit eventKey="carbonMonitoring">
              <ExpenseBifurcationTable tableData={tableData.slice(8, 12)} />
            </Tab.Pane>
            <Tab.Pane unmountOnExit eventKey="projectManagement">
              <ExpenseBifurcationTable tableData={tableData.slice(12, 16)} />
            </Tab.Pane>
          </Tab.Content>
        </Card.Body>
      </Tab.Container>

      <Card.Footer className="bg-body-tertiary py-2">
        <Row className="g-0 flex-between-center">
          <Col xs="auto">
            <Form.Select size="sm" className="me-2">
              <option>Project A</option>
              <option>Projedt B</option>
            </Form.Select>
          </Col>
        </Row>
      </Card.Footer>
    </Card>
  );
};

TabTitle.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  isPaid: PropTypes.bool,
  isActive: PropTypes.bool
};

ExpenseBifurcation.propTypes = {
  tableData: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string
};

export default ExpenseBifurcation;
